export default __webpack_public_path__ + "static/media/googleanalytics-dark.cae89c3a.png";